// Local translations
export const T = {
  en_GB: {
    editProduct: "Edit Product",
    addNewProduct: "Add New Product",
    editDescription: "Update the product information below.",
    createDescription:
      "Add a new product to the register. Products can be reused across multiple portfolios.",
    tabGeneral: "General",
    tabSuitability: "Suitability",
    tabCosts: "Costs",
    tabAllocation: "Allocation",
    tabDocuments: "Documents",
    tabClientPreferences: "Client preferences",
    tabCalculationInput: "Calculation input",
    calculationInputDescription:
      "Expected return and volatility drive portfolio calculations for this collection while its Calculations Mode is set to Products. Leave empty for not entered.",
    expectedReturn: "Expected Return",
    expectedReturnPlaceholder: "e.g., 5.5",
    expectedReturnInvalid: "Expected return must be a number",
    expectedVolatility: "Expected Volatility",
    expectedVolatilityPlaceholder: "e.g., 12.0",
    expectedVolatilityInvalid: "Expected volatility must be 0 or greater",
    clientPreferencesDescription:
      "Tag whether this product has each trait defined by the collection's client preferences. Off counts as not having the trait.",
    clientPreferencesUnitsNotAllowed:
      "A product ordered in units cannot carry a client preference.",
    linkToInstrument: "Link to Instrument Database (Optional)",
    searchInstrumentDatabase: "Search Instrument Database",
    patchInstrument: "Patch Instrument Information",
    linkDescription:
      "Link this product to an instrument in the database to automatically populate name and ISIN",
    productName: "Product Name",
    productNamePlaceholder: "e.g., DNB Norge A",
    isinOptional: "ISIN (Optional)",
    isinPlaceholder: "e.g., NO0010819915",
    isinDescription:
      "International Securities Identification Number. Products without ISIN will be excluded from X-Ray analysis.",
    descriptionOptional: "Description (optional)",
    descriptionPlaceholder: "Optional product description, metadata, or notes",
    suitabilityDescription:
      "Define the minimum criteria required for this product. These settings are used to check if a product is suitable for a client based on their profile and investment goals.",
    platforms: "Platforms",
    platformsDescription:
      "Platforms this product is available under. None selected = not available under any platform. The product must cover ALL platforms of every model portfolio it is in.",
    wrapperTypes: "Wrapper Types",
    wrapperTypesDescription:
      "Account wrapper types this product may be held in, in order of preference (1 = preferred).",
    addWrapperType: "+ Add wrapper type...",
    removeWrapperType: "Remove",
    removeInstrument: "Remove instrument",
    removeAllocation: "Remove allocation",
    moveUp: "Move up",
    moveDown: "Move down",
    sustainabilitySection: "Sustainability",
    sustainabilityDescription:
      "SFDR and mapped product preferences are resolved automatically from the linked Morningstar instrument's SFDR type, stated exclusions and product involvement; override where needed. Other criteria use the product's own value.",
    sustainabilitySelectStep: "Select step",
    sfdrShort: "SFDR",
    morningstarSfdrHint: "Morningstar EU SFDR type:",
    sfdrFromMorningstar: "From Morningstar:",
    sfdrOverride: "Override",
    sfdrUseMorningstar: "Use Morningstar value",
    sfdrManualHint: "This instrument has no Morningstar SFDR type — choose a score manually.",
    sfdrSelectScore: "Select score",
    productPreferenceFromMorningstar: "From Morningstar",
    productPreferenceOverride: "Override",
    productPreferenceAuto: "Auto",
    productPreferenceExcluded: "Excluded",
    productPreferenceNotExcluded: "Not excluded",
    productPreferenceClean: "Not involved",
    productPreferenceNotClean: "Involved",
    productPreferenceOverridePositive: "Excluded / Not involved",
    productPreferenceOverrideNegative: "Involved / Not excluded",
    productType: "Product Type",
    costClass: "Cost Class",
    selectCostClass: "Select a cost class",
    noCostClassesConfigured: "No cost classes configured",
    costClassDescription:
      "Classification used for manual fee mapping (e.g. brokerage class or fund type). Separate from product type.",
    orderType: "Order Type",
    orderTypeAmount: "Amount",
    orderTypeUnits: "Units",
    orderTypeDescription:
      "How this product is ordered. 'Units' requires a valid instrument last price and cannot be used in model portfolios. Cannot be changed after the product is created.",
    orderTypeImmutable: "Order type cannot be changed after creation.",
    lastPriceLabel: "Last price",
    unitsNeedLastPrice: "Requires a linked instrument with a last price",
    noProductTypesConfigured: "No product types configured",
    selectProductType: "Select product type...",
    none: "None",
    productTypeDescription: "Client must have experience with this type to invest",
    minTimeHorizon: "Min. Time Horizon",
    noTimeHorizonsConfigured: "No time horizons configured",
    selectMinTimeHorizon: "Select minimum time horizon...",
    minTimeHorizonDescription: "Client must have at least this time horizon to invest",
    minRiskTolerance: "Min. Risk Tolerance",
    noRiskLevelsConfigured: "No risk levels configured",
    selectMinRiskTolerance: "Select minimum risk tolerance...",
    minRiskToleranceDescription: "Client must have at least this risk tolerance to invest",
    minRiskScore: "Min. Risk Score",
    selectMinRiskScore: "Select minimum risk score...",
    minRiskScoreDescription:
      "Client's risk score must be at least this value to invest. Values come from this collection's risk matrix.",
    minRiskScoreNoMatrix: "Requires a risk model with a populated matrix on this collection",
    minBuyAmount: "Minimum buy amount",
    minBuyAmountOptional: "Optional",
    minBuyAmountPlaceholder: "e.g., 100",
    minBuyAmountDescription:
      "Smallest allowed buy per event (a one-time buy or each recurring occurrence), in the collection currency. Leave empty for no minimum.",
    minBuyAmountInvalid: "Minimum buy amount must be 0 or greater",
    allocationDescription:
      "Define how this product is allocated across asset classes (optional). If set, allocations must sum to 100%.",
    noAllocationSet: "No asset allocation set",
    addAllocation: "+ Add Allocation",
    allocationMode: "Allocation Mode",
    single100: "Single (100%)",
    multiple: "Multiple",
    assetClass: "Asset Class",
    selectAssetClass: "Select asset class...",
    allocated100: "Product will be 100% allocated to this asset class",
    addAssetClass: "+ Add asset class...",
    total: "Total",
    clearAllocation: "Clear Allocation",
    cancel: "Cancel",
    save: "Save",
    addProduct: "Add Product",
    failedToSave: "Failed to save product",
    somethingWentWrong: "Something went wrong",
    allocationMustSum: "Asset allocation weights must sum to 100%",
    allocationCannotBeRemoved:
      "Once set, an asset allocation can only be replaced by another valid allocation summing to 100%, not removed.",
    overrideMustBePositive: "Overridden cost values must be 0 or greater",
    nameRequired: "Name is required",
    fetchFailed: "Failed to fetch instrument details.",
    notLinkedWarning:
      "Product will NOT be linked to the database. You can still save it with the search data (name and ISIN).",
    instrumentDuration: "Instrument Duration",
    combinedDuration: "Combined Duration",
    instrumentCurrency: "Currency",
    patchCurrencyMismatch: (patch: string, instrument: string) =>
      `Patch is in ${patch}, instrument is in ${instrument}`,
    patchNotNeeded: (years: string) =>
      `The instrument already has ${years} years of history of its own, so it does not need a patch.`,
  },
  nb_NO: {
    editProduct: "Rediger produkt",
    addNewProduct: "Legg til nytt produkt",
    editDescription: "Oppdater produktinformasjonen nedenfor.",
    createDescription:
      "Legg til et nytt produkt i registeret. Produkter kan gjenbrukes på tvers av flere porteføljer.",
    tabGeneral: "Generelt",
    tabSuitability: "Egnethet",
    tabCosts: "Kostnader",
    tabAllocation: "Allokering",
    tabDocuments: "Dokumenter",
    tabClientPreferences: "Kundepreferanser",
    tabCalculationInput: "Beregningsinput",
    calculationInputDescription:
      "Forventet avkastning og volatilitet styrer porteføljeberegninger for denne samlingen mens beregningsmodus er satt til Produkter. La stå tomt hvis ikke oppgitt.",
    expectedReturn: "Forventet avkastning",
    expectedReturnPlaceholder: "f.eks. 5,5",
    expectedReturnInvalid: "Forventet avkastning må være et tall",
    expectedVolatility: "Forventet volatilitet",
    expectedVolatilityPlaceholder: "f.eks. 12,0",
    expectedVolatilityInvalid: "Forventet volatilitet må være 0 eller større",
    clientPreferencesDescription:
      "Merk om dette produktet har hver egenskap definert av samlingens kundepreferanser. Av teller som at produktet ikke har egenskapen.",
    clientPreferencesUnitsNotAllowed:
      "Et produkt som bestilles i andeler kan ikke ha en kundepreferanse.",
    linkToInstrument: "Koble til instrumentdatabase (valgfritt)",
    searchInstrumentDatabase: "Søk i instrumentdatabase",
    patchInstrument: "Oppdater instrumentinformasjon",
    linkDescription:
      "Koble dette produktet til et instrument i databasen for å automatisk fylle inn navn og ISIN",
    productName: "Produktnavn",
    productNamePlaceholder: "f.eks. DNB Norge A",
    isinOptional: "ISIN (valgfritt)",
    isinPlaceholder: "f.eks. NO0010819915",
    isinDescription:
      "International Securities Identification Number. Produkter uten ISIN vil bli ekskludert fra X-Ray-analyse.",
    descriptionOptional: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Valgfri produktbeskrivelse, metadata eller notater",
    suitabilityDescription:
      "Definer minimumskravene for dette produktet. Disse innstillingene brukes til å sjekke om et produkt passer for en kunde basert på deres profil og investeringsmål.",
    platforms: "Plattformer",
    platformsDescription:
      "Plattformer dette produktet er tilgjengelig under. Ingen valgt = ikke tilgjengelig under noen plattform. Produktet må dekke ALLE plattformene til hver modellportefølje det inngår i.",
    wrapperTypes: "Innpakningstyper",
    wrapperTypesDescription:
      "Innpakningstyper for kontoer dette produktet kan holdes i, i prioritert rekkefølge (1 = foretrukket).",
    addWrapperType: "+ Legg til innpakningstype...",
    removeWrapperType: "Fjern",
    removeInstrument: "Fjern instrument",
    removeAllocation: "Fjern allokering",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    sustainabilitySection: "Bærekraft",
    sustainabilityDescription:
      "SFDR og tilknyttede produktpreferanser hentes automatisk fra det tilknyttede Morningstar-instrumentets SFDR-type, uttalte eksklusjoner og produktinvolvering; overstyr ved behov. Andre kriterier bruker produktets egen verdi.",
    sustainabilitySelectStep: "Velg trinn",
    sfdrShort: "SFDR",
    morningstarSfdrHint: "Morningstar EU SFDR-type:",
    sfdrFromMorningstar: "Fra Morningstar:",
    sfdrOverride: "Overstyr",
    sfdrUseMorningstar: "Bruk Morningstar-verdi",
    sfdrManualHint: "Dette instrumentet har ingen Morningstar SFDR-type — velg en verdi manuelt.",
    sfdrSelectScore: "Velg verdi",
    productPreferenceFromMorningstar: "Fra Morningstar",
    productPreferenceOverride: "Overstyr",
    productPreferenceAuto: "Auto",
    productPreferenceExcluded: "Ekskludert",
    productPreferenceNotExcluded: "Ikke ekskludert",
    productPreferenceClean: "Ikke involvert",
    productPreferenceNotClean: "Involvert",
    productPreferenceOverridePositive: "Ekskludert / Ikke involvert",
    productPreferenceOverrideNegative: "Involvert / Ikke ekskludert",
    productType: "Produkttype",
    costClass: "Kostnadsklasse",
    selectCostClass: "Velg en kostnadsklasse",
    noCostClassesConfigured: "Ingen kostnadsklasser konfigurert",
    costClassDescription:
      "Klassifisering brukt for kobling av manuelle kostnader (f.eks. kurtasjeklasse eller fondstype). Atskilt fra produkttype.",
    orderType: "Ordretype",
    orderTypeAmount: "Beløp",
    orderTypeUnits: "Andeler",
    orderTypeDescription:
      "Hvordan produktet bestilles. 'Andeler' krever en gyldig sist-pris på instrumentet og kan ikke brukes i modellporteføljer. Kan ikke endres etter at produktet er opprettet.",
    orderTypeImmutable: "Ordretype kan ikke endres etter opprettelse.",
    lastPriceLabel: "Sist pris",
    unitsNeedLastPrice: "Krever et tilknyttet instrument med en sist-pris",
    noProductTypesConfigured: "Ingen produkttyper konfigurert",
    selectProductType: "Velg produkttype...",
    none: "Ingen",
    productTypeDescription: "Kunden må ha erfaring med denne typen for å investere",
    minTimeHorizon: "Min. tidshorisont",
    noTimeHorizonsConfigured: "Ingen tidshorisonter konfigurert",
    selectMinTimeHorizon: "Velg minimum tidshorisont...",
    minTimeHorizonDescription: "Kunden må ha minst denne tidshorisonten for å investere",
    minRiskTolerance: "Min. risikotoleranse",
    noRiskLevelsConfigured: "Ingen risikonivåer konfigurert",
    selectMinRiskTolerance: "Velg minimum risikotoleranse...",
    minRiskToleranceDescription: "Kunden må ha minst denne risikotoleransen for å investere",
    minRiskScore: "Min. risikoscore",
    selectMinRiskScore: "Velg minimum risikoscore...",
    minRiskScoreDescription:
      "Kundens risikoscore må være minst denne verdien for å investere. Verdiene kommer fra kolleksjonens risikomatrise.",
    minRiskScoreNoMatrix: "Krever en risikomodell med utfylt matrise på denne kolleksjonen",
    minBuyAmount: "Minimumsbeløp per kjøp",
    minBuyAmountOptional: "Valgfritt",
    minBuyAmountPlaceholder: "f.eks. 100",
    minBuyAmountDescription:
      "Minste tillatte kjøp per hendelse (et engangskjøp eller hver gjentakende forekomst), i porteføljesamlingens valuta. La stå tomt for ingen minimum.",
    minBuyAmountInvalid: "Minimumsbeløp per kjøp må være 0 eller større",
    allocationDescription:
      "Definer hvordan dette produktet er fordelt på tvers av aktivaklasser (valgfritt). Hvis satt, må allokeringer summere til 100%.",
    noAllocationSet: "Ingen aktivaallokering satt",
    addAllocation: "+ Legg til allokering",
    allocationMode: "Allokeringsmodus",
    single100: "Enkel (100%)",
    multiple: "Flere",
    assetClass: "Aktivaklasse",
    selectAssetClass: "Velg aktivaklasse...",
    allocated100: "Produktet vil bli 100% allokert til denne aktivaklassen",
    addAssetClass: "+ Legg til aktivaklasse...",
    total: "Totalt",
    clearAllocation: "Fjern allokering",
    cancel: "Avbryt",
    save: "Lagre",
    addProduct: "Legg til produkt",
    failedToSave: "Kunne ikke lagre produkt",
    somethingWentWrong: "Noe gikk galt",
    allocationMustSum: "Aktivaallokeringsvekter må summere til 100%",
    allocationCannotBeRemoved:
      "Når den først er satt, kan en aktivaallokering kun erstattes med en annen gyldig allokering som summerer til 100%, ikke fjernes.",
    overrideMustBePositive: "Overstyrte kostnadsverdier må være 0 eller større",
    nameRequired: "Navn er påkrevd",
    fetchFailed: "Kunne ikke hente instrumentdetaljer.",
    notLinkedWarning:
      "Produktet vil IKKE bli koblet til databasen. Du kan fortsatt lagre det med søkedataene (navn og ISIN).",
    instrumentDuration: "Instrumentvarighet",
    combinedDuration: "Samlet varighet",
    instrumentCurrency: "Valuta",
    patchCurrencyMismatch: (patch: string, instrument: string) =>
      `Patchen er i ${patch}, instrumentet er i ${instrument}`,
    patchNotNeeded: (years: string) =>
      `Instrumentet har allerede ${years} års egen historikk og trenger derfor ingen patch.`,
  },
} as const;
